import React from "react";
import { Container, Row, Col, Card, CardImg } from "reactstrap";
import { scroller } from "react-scroll";
// import cn from "classnames";

import ImageContainer from "../image-container/image-container";

import arrow from "../../images/flechab.png";
import email from "../../images/iconomail.jpg";
import ofelia from "../../images/ofeliafoto.png";
import * as style from "./description.module.scss";

const Description = () => {
  const scrollToSection = () => {
    scroller.scrollTo(style.description, {
      duration: 120,
      smooth: "easeInOutQuad",
      offset: 50,
    });
  };

  return (
    <Container fluid className={style.description}>
      <Row>
        <Col
          xs={{ size: "5", offset: "4" }}
          sm={{ size: "4", offset: "4" }}
          md={{ size: "4", offset: "4" }}
          lg={{ size: "4", offset: "4" }}
          xl={{ size: "2", offset: "5" }}
        >
          <Card
            className={style.arrow__container}
            onClick={() => scrollToSection()}
          >
            <CardImg top src={arrow} alt="Arrow Down" />
          </Card>
        </Col>
      </Row>
      <Row>
        <Col
          xs="12"
          sm="12"
          md={{ size: "6", offset: "1" }}
          className={style.description__text}
        >
          <span className={style.description__hello}>
            <b>Hola!</b>
          </span>
          <p className={style.description__hello_text}>
            Soy ingeniera técnica en Diseño industrial, con una especialidad en
            identidad Corporativa y cuento con la experiencia de haber
            desarrollado trabajos en diferentes ámbitos del diseño tales como
            diseño gráfico, branding, diseño web, impresion 3d,packaging..
          </p>
        </Col>
        <Col
          xs={{ size: "11", offset: "1" }}
          sm={{ size: "11", offset: "1" }}
          md={{ size: "6", offset: "5" }}
          lg={{ size: "6", offset: "5" }}
          xl={{ size: "4", offset: "7" }}
          className={style.description__card}
        >
          <Col
            xs={{ size: "12" }}
            sm={{ size: "12" }}
            md={{ size: "12" }}
            lg={{ size: "12" }}
            xl={{ size: "12" }}
          >
            <p className={style.description__card__text}>
              Me considero una diseñadora con la experiencia necesaria para
              abordar cualquier proyecto de diseño, si quieres contactar conmigo
              envíame un correo, para cualquier consulta.
            </p>
            <a
              className={style.description__card__email}
              href="mailto:ofeliataedo@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              ofelitadeo@gmail.com
              <ImageContainer
                classImg={style.description__card__email__logo}
                image={email}
                alt="Email"
              />
            </a>
          </Col>
          <Col
            xs={{ size: "3", offset: "9" }}
            sm={{ size: "3", offset: "9" }}
            md={{ size: "3", offset: "9" }}
            lg={{ size: "3", offset: "9" }}
            xl={{ size: "2", offset: "9" }}
            className={style.description__card__foto__container}
          >
            <CardImg
              className={style.description__card__foto__container__foto}
              top
              src={ofelia}
              alt="Ofelia Tadeo Perez"
            />
          </Col>
        </Col>
      </Row>
    </Container>
  );
};

export default Description;
